import { Column, DataGrid, Item, Toolbar } from 'devextreme-react/data-grid';
import { Tooltip } from 'devextreme-react/tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { Circle } from 'react-feather';
import { toast } from 'react-toastify';
import { Button, Card } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import ExportButton from '../../components/ui/ExportButton';
import RefreshButton from '../../components/ui/RefreshButton';
import api from '../../services/api-configuration-v3';
import useFormatMessage from '../../utils/useFormatMessage';

const SevkBlokajKuyruk = () => {
    const [dataSource, setDataSource] = useState([])
    const dataGridRef = useRef()
    const { t } = useFormatMessage()


    // Status lookup datasource
    const statusLookup = [
        { value: 'COMPLETED', text: 'TAMAMLANDI' },
        { value: 'WAITING', text: 'BEKLİYOR' },
        { value: 'WAITING_INVOICE', text: 'FATURA BEKLİYOR' },
        { value: 'DEALER_NOT_MATCH', text: 'BAYİ EŞLEŞMİYOR' }
    ]

    // Process type lookup datasource
    const processTypeLookup = [
        { value: 'BLOCKING_SHIPPING', text: 'BLOKAJ' },
        { value: 'SHIPPING_BLOCKING', text: 'SEVK' }
    ]

    // Tarih formatı fonksiyonu
    const getSuspendedData = async () => {
        if (dataGridRef?.current?.instance) dataGridRef.current.instance.beginCustomLoading(`${t("Yükleniyor")}...`);
        try {
            const response = await api.post("/getAllSuspendedOrders")
            setDataSource(response.data || [])
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.error || t("Veri alınırken bir hata oluştu"))
        }
        finally {
            if (dataGridRef?.current?.instance) dataGridRef.current.instance.endCustomLoading();
        }

    }

    useEffect(() => {
        getSuspendedData()
    }, [])

    // Row styling based on status
    const onRowPrepared = (e) => {
        if (e.rowType === 'data') {
            if (e.data.status === 'COMPLETED') {
                e.rowElement.classList.add('completed-row')
            } else if (e.data.status === 'DEALER_NOT_MATCH') {
                e.rowElement.classList.add('dealer-not-match-row')
            }
        }
    }

    const onCellPrepared = (e) => {
        if (e.rowType === 'data' && e?.column?.dataField === "data.client code") {
            if (
                (e.data.status === 'WAITING_INVOICE' || e.data.status === 'WAITING')
                && e.text === ""
                && e.data.data["sevk/blokaj bilgisi"] === 'SEVK'
            ) {

                e.cellElement.style.backgroundColor = '#ff7373'
            } else e.cellElement.style.backgroundColor = 'transparent'
        }
    }

    const headerCellRenderClientCode = (e) => {
        return (
            <>
                <i className='fa fa-info-circle' style={{ color: '#ff7373' }} id='client-code-tooltip'></i>  Client Code
                <Tooltip target='#client-code-tooltip'
                    showEvent='mouseenter'
                    hideEvent='mouseleave'
                    position={{
                        of: '#client-code-tooltip',
                        my: 'bottom',
                        at: 'top'
                    }}
                >
                    <div className='d-flex align-items-center justify-content-start' >
                        <Circle color='#ff7373' size={13} fill='#ff7373' /> &emsp;  <p className='p-0 m-0' style={{ textAlign: 'left' }}> Sevkiyat Yeri Tanımlanmamış Adresler; <br /> Bu adresleri "Sevkiyat Yerleri" tablosundan tanımlayınız.</p>
                    </div>
                </Tooltip>

            </>)

    }

    return (
        <>
            <Breadcrumb current="Tanımsız Araç Sevk/Blokaj Takibi" />
            <Card className='p-3'>

                <DataGrid
                    ref={dataGridRef}
                    dataSource={dataSource}
                    onRowPrepared={onRowPrepared}
                    onCellPrepared={onCellPrepared}
                    showBorders={true}
                    showRowLines={true}
                    showColumnLines={true}
                    columnAutoWidth={true}
                    height={800}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    filterRow={{
                        visible: true,
                        applyFilter: 'auto',
                        operationDescriptions: {
                            contains: "İçeriyor",
                            notContains: "İçermiyor",
                            equals: "Eşittir",
                            notEquals: "Eşit değil",
                            greaterThan: "Büyüktür",
                            lessThan: "Küçüktür",
                            greaterThanOrEqual: "Büyük eşit",
                            lessThanOrEqual: "Küçük eşit",
                            between: "Arasında",
                            notBetween: "Arasında değil",
                            isNull: "Boş",
                            isNotNull: "Boş değil",
                            reset: "Sıfırla",

                            endsWith: "Bitişi",
                            startsWith: "Başlangıçı",
                            doesNotContain: "İçermiyor",
                            doesNotEqual: "Eşit değil",
                            doesNotStartWith: "Başlangıçı değil",
                            doesNotEndWith: "Bitişi değil",
                            equal: "Eşit",
                            notEqual: "Eşit değil"
                        }
                    }}
                    groupPanel={{
                        visible: true,
                        allowColumnDragging: true,
                        allowReordering: true,
                        allowCollapsing: true,
                        allowExpanding: true,
                        emptyPanelText: "Gruplamak için kolon başlığını buraya sürükleyin"
                    }}
                    summary={{
                        totalItems: [{
                            column: "chassis_no",
                            summaryType: "count",
                            displayFormat: "Toplam: {0}"
                        }],
                        groupItems: [{
                            column: "chassis_no",
                            summaryType: "count",
                            displayFormat: "{0}"
                        }]
                    }}
                    paging={{
                        enabled: true,
                        pageSize: 20,
                        showPageSizeSelector: true,
                        showInfo: true,
                        showNavigationButtons: true,
                        showAll: true,
                        showFirst: true,
                        showLast: true,
                    }}
                    pager={
                        {
                            enabled: true,
                            pageSize: 20,
                            showPageSizeSelector: true,
                            allowedPageSizes: [50, 100, 200, 500],
                            showInfo: true,
                            showNavigationButtons: true,
                            showAll: true,
                            showFirst: true,
                            showLast: true,
                        }
                    }
                    sorting={{
                        mode: 'multiple'
                    }}

                >
                    {/* <StateStoring
                        enabled={true}
                        type="localStorage"
                        savingTimeout={100}
                        storageKey='sevk-blokaj-kuyruk'
                        
                    /> */}
                    <Column dataField="chassis_no" caption="Şase" />
                    <Column
                        dataField="data.tarih"
                        caption="Tarih"
                        dataType='datetime'
                        format='dd.MM.yyyy HH:mm:ss'
                    />

                    <Column
                        dataField="data"
                        name='talep eden bayi'
                        caption="Talep Eden Bayi"
                        calculateCellValue={(rowData) => {
                            try {
                                const data = typeof rowData.data === 'string' ? JSON.parse(rowData.data) : rowData.data;
                                return data?.['talep eden bayi'] || '';
                            } catch {
                                return '';
                            }
                        }}
                    />
                    <Column
                        dataField="data.sevk/blokaj bilgisi"
                        name='sevk/blokaj'
                        caption="Sevk/Blokaj"
                        width={95}

                    />
                    {/* client code */}
                    <Column
                        dataField="data.client code"
                        name='client_code'
                        caption="Client Code"
                        width={115}
                        headerCellRender={headerCellRenderClientCode}
                    />

                    <Column
                        dataField="data"
                        name='sevk istenen adres'
                        caption="Sevk İstenen Adres"
                        calculateCellValue={(rowData) => {
                            try {
                                const data = typeof rowData.data === 'string' ? JSON.parse(rowData.data) : rowData.data;
                                return data?.['sevk istenen adres'] || '';
                            } catch {
                                return '';
                            }
                        }}
                    />
                    <Column
                        dataField="data"
                        name='sevk il'
                        caption="Sevk İl"
                        calculateCellValue={(rowData) => {
                            try {
                                const data = typeof rowData.data === 'string' ? JSON.parse(rowData.data) : rowData.data;
                                return data?.['sevk il'] || '';
                            } catch {
                                return '';
                            }
                        }}
                    />
                    {/* <Column
                        dataField="process_type"
                        caption="İşlem Tipi"
                        lookup={{
                            dataSource: processTypeLookup,
                            valueExpr: 'value',
                            displayExpr: 'text'
                        }}
                    /> */}
                    <Column
                        dataField="status"
                        caption="Durum"
                        lookup={{
                            dataSource: statusLookup,
                            valueExpr: 'value',
                            displayExpr: 'text'
                        }}
                    />
                    <Column
                        dataField="create_date"
                        caption="Oluşturulma Tarihi"
                        width={150}
                        dataType='datetime'
                        format='dd.MM.yyyy HH:mm'
                    />
                    <Column
                        dataField="process_date"
                        caption="İşlem Tarihi"
                        dataType='datetime'
                        format='dd.MM.yyyy HH:mm'
                        width={121}
                    />
                    <Column dataField="create_user_name" caption="Oluşturan Kullanıcı" />

                    <Toolbar>
                        <Item name="groupPanel" />
                        <Item location='after'>
                            <Button
                                color="light"
                                id='reset-button'
                                outline
                                height={"100%"}
                                style={{ paddingInline: "10px", border: "1px solid #ddd", color: "black" }}
                                text="Reset"
                                onClick={() => {
                                    localStorage.removeItem('sevk-blokaj-kuyruk')
                                    if (dataGridRef.current) {
                                        dataGridRef.current.instance.clearSorting();
                                        dataGridRef.current.instance.clearFilter();
                                        dataGridRef.current.instance.clearGrouping();
                                        dataGridRef.current.instance.clearSelection();

                                    }
                                }}
                            >
                                <i class="fa fa-filter" aria-hidden="true"></i><span style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}>x</span>
                            </Button>

                        </Item>
                        <Item location='after'>
                            <RefreshButton onClick={getSuspendedData} />
                        </Item>
                        <Item location='after'>
                            <ExportButton
                                onClick={getSuspendedData}
                                refValue={dataGridRef}
                                title="Sevk Blokaj Kuyruk"
                                sheetName="Sayfa-1"

                            />
                        </Item>

                    </Toolbar>
                </DataGrid>
            </Card>
            <Tooltip showEvent="mouseenter"
                hideEvent="mouseleave"
                position={{
                    of: "#reset-button",
                    my: "bottom",
                    at: "top"
                }}
                animation={{
                    show: {
                        type: 'pop',
                        duration: 300
                    }
                }}
                hideOnOutsideClick={false} target="#reset-button" >

                <div style={{ padding: "5px", borderRadius: "5px", backgroundColor: "#f8f9fa", color: "black" }}>
                    {t("Sıralamayı, filtreleri ve gruplamayı temizler")}
                </div>
            </Tooltip>

            <style jsx>{`
                .completed-row td {
                    background-color: #d4edda !important;
                }
                .dealer-not-match-row td {
                    background-color: #f8d7da !important;
                }
                .dx-group-row td {
                    background-color:rgb(248, 248, 248) !important;
                }
            `}</style>
        </>
    )
}

export default SevkBlokajKuyruk